import React from "react";
import Render from "components/Common/Render";
import Button from "components/Buttons/Button";
import { INavigationButtonsProps } from "containers/OnboardingBusiness/types";

const NavigationButtons: React.FC<INavigationButtonsProps> = ({
  currentStep,
  totalSteps,
  onNext,
  onPrevious,
  onSkip,
  isSubmitting,
  isNextDisabled,
}) => {
  return (
    <>
      {/* Mobile View - Fixed to bottom */}
      <div className="md:hidden mobile-nav-buttons flex gap-3">
        <Render when={currentStep === totalSteps}>
          <div className="flex-1">
            <Button
              label="Finish"
              onClick={onSkip}
              variant="primary"
              customClass="!mb-0 !me-0 w-full min-h-[48px]"
            />
          </div>
        </Render>
        <Render when={currentStep < totalSteps}>
          <div className="flex-1">
            <Button
              label={isSubmitting ? "Submitting..." : "Next Step"}
              onClick={onNext}
              disabled={isSubmitting || isNextDisabled}
              variant="primary"
              customClass="!mb-0 !me-0 w-full min-h-[48px]"
            />
          </div>
        </Render>
      </div>

      {/* Desktop View - Aligned with Form Content */}
      <div className="hidden md:flex justify-between items-center gap-4 pb-0 px-4 md:px-0">
        <div className="flex items-center">
          {/* Show Cancel button only on step 3 (Business Photos) */}
          <Render when={currentStep === 3}>
            <Button
              label="Cancel"
              onClick={onSkip}
              variant="secondary"
              customClass="!mb-0 !me-0 !border-[#FB4C2F] !text-[#FB4C2F] hover:!bg-red-50"
            />
          </Render>
          {/* Show Go back button on step 2 */}
          <Render when={currentStep === 2}>
            <Button
              label="Go back"
              onClick={onPrevious}
              variant="secondary"
              customClass="!mb-0 !me-0"
            />
          </Render>
        </div>
        <div className="flex items-center">
          <Render when={currentStep === totalSteps}>
            <Button
              label="Finish"
              onClick={onSkip}
              variant="primary"
              customClass="!mb-0 !me-0"
            />
          </Render>
          <Render when={currentStep < totalSteps}>
            <Button
              label={isSubmitting ? "Submitting..." : "Next Step"}
              onClick={onNext}
              disabled={isSubmitting || isNextDisabled}
              variant="primary"
              customClass="!mb-0 !me-0"
            />
          </Render>
        </div>
      </div>
    </>
  );
};

export default NavigationButtons;
